export const colorDistributionActions = {
    COLOR_DISTRIBUTION_SET_BWIC_COLOR_DISTRIBUTION: 'COLOR_DISTRIBUTION_SET_BWIC_COLOR_DISTRIBUTION',
    COLOR_DISTRIBUTION_TRADED_TYPE_CHANGE: 'COLOR_DISTRIBUTION_TRADED_TYPE_CHANGE',
    COLOR_DISTRIBUTION_DNT_TYPE_CHANGE: 'COLOR_DISTRIBUTION_DNT_TYPE_CHANGE',
    COLOR_DISTRIBUTION_POSITION_COLOR_TYPE_CHANGE: 'COLOR_DISTRIBUTION_POSITION_COLOR_TYPE_CHANGE',
    COLOR_DISTRIBUTION_COMPLETE_IN_PROGRESS: 'COLOR_DISTRIBUTION_COMPLETE_IN_PROGRESS',
    COLOR_DISTRIBUTION_RESET: 'COLOR_DISTRIBUTION_RESET'
}
